export default __webpack_public_path__ + "static/media/1.dd2f946a.jpg";